import React, { useMemo } from 'react';
import { StyleSheet, TextInput, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';

const createStyles = (colors, isPrimary = false, noSpacing = false) => StyleSheet.create({
  textareaContainer: {
    width: '100%',
    paddingHorizontal: noSpacing ? 0 : 12,
    paddingBottom: noSpacing ? 0 : 15,
  },
  textareaInputContainerMultiList: {
    width: '100%',
    gap: noSpacing ? 0 : 15,
    marginBottom: noSpacing ? 0 : 15,
  },
  textareaInputContainerMulti: {
    width: '100%',
    marginBottom: 0,
  },
  textareaInputContainerMultiLast: {
    marginBottom: 0,
  },
  textareaMultiLabel: {
    fontSize: 12,
    fontWeight: '500',
    color: colors.text_color_secondary,
    marginBottom: noSpacing ? 10 : 12,
    marginTop: noSpacing ? 10 : 0,
  },
  textareaInputWrapper: {
    backgroundColor: isPrimary ? colors.solid_color_primary : colors.solid_color_tertiary,
    borderColor: isPrimary ? colors.border_color_secondary : 'transparent',
    borderWidth: isPrimary ? 1 : 0,
    borderRadius: 8,
  },
  textareaInput: {
    color: colors.text_color_primary,
    paddingHorizontal: 12,
    paddingVertical: 8,
    minHeight: 88,
    maxHeight: 220,
    width: '100%',
    fontSize: 14,
    lineHeight: 18,
    border: 'none',
    resize: 'vertical',
    outlineStyle: 'none',
  },
  textareaDescription: {
    fontSize: 12,
    color: colors.text_color_tertiary,
    marginTop: -12,
    marginBottom: 16,
    textAlign: 'left',
    fontStyle: 'italic',
  },
  textareaDescriptionExtra: {
    marginTop: 4,
    marginBottom: 12,
    fontStyle: 'italic',
  },
});

const TextareaMultiControl = ({ param, onChange, isPrimary = false, withoutHeaderText = false, noSpacing = false }) => {
  const { colors } = useTheme();
  const styles = useMemo(() => createStyles(colors, isPrimary, noSpacing), [colors, isPrimary, noSpacing]);
  const handleFieldChange = (key, text) => {
    onChange({
      ...param.value,
      [key]: text
    });
  };

  return (
    <View style={styles.textareaContainer}>
      {!withoutHeaderText && <Text style={styles.textareaDescription}>{param.ui?.description || param.description}</Text>}
      
      <View style={styles.textareaInputContainerMultiList}>
        {param.validation.fields.map((field, index) => (
          <View
            style={[
              styles.textareaInputContainerMulti,
              index === param.validation.fields.length - 1 && styles.textareaInputContainerMultiLast
            ]}
            key={`textarea-multi-${field.key || index}`}
          >
            <Text style={styles.textareaMultiLabel}>{field.label}</Text>
            <View style={styles.textareaInputWrapper}>
              <TextInput
                multiline={true}
                value={param.value?.[field.key] ?? ''}
                onChangeText={(text) => handleFieldChange(field.key, text)}
                placeholder={field.placeholder}
                placeholderTextColor={colors.text_color_tertiary}
                style={styles.textareaInput}
                maxLength={field.maxLength || undefined}
              />
            </View>
            {field.description && (
              <Text style={[styles.textareaDescription, styles.textareaDescriptionExtra]}>
                {field.description}
              </Text>
            )}
          </View>
        ))}
      </View>
    </View>
  );
};

export default TextareaMultiControl;

